/* The dashboard's words for the shared sign-in and setup screens, from its own
 * English-only table. The till's kiosk passes its own table's words to the same
 * screens. */
import type { MerchantSetupWords, MerchantSignInWords } from "@damga/ds";

import { t } from "../content";

export const signInWords: MerchantSignInWords = {
  title: t("auth.title"),
  body: t("auth.body"),
  username: t("auth.username"),
  password: t("auth.password"),
  showPassword: t("auth.show"),
  hidePassword: t("auth.hide"),
  submit: t("auth.submit"),
  working: t("auth.working"),
  refused: t("auth.refused"),
  codeTitle: t("auth.codeTitle"),
  codeBody: t("auth.codeBody"),
  codeLabel: t("auth.codeLabel"),
  verify: t("auth.verify"),
  codeRefused: t("auth.codeRefused"),
  codeIncomplete: t("auth.codeIncomplete"),
  startAgain: t("auth.startAgain"),
  tooManyCodes: t("auth.tooManyCodes"),
  mailDown: t("auth.mailDown"),
  unreachable: t("auth.unreachable"),
};

export const setupWords: MerchantSetupWords = {
  checking: t("setup.checking"),
  title: t("setup.title"),
  body: t("setup.body"),
  username: t("setup.username"),
  newPassword: t("setup.new"),
  confirmPassword: t("setup.confirm"),
  rule: t("setup.rule"),
  mismatch: t("setup.mismatch"),
  weak: t("setup.weak"),
  submit: t("setup.submit"),
  working: t("auth.working"),
  doneTitle: t("setup.doneTitle"),
  doneBody: t("setup.doneBody"),
  signIn: t("setup.signIn"),
  deadTitle: t("setup.deadTitle"),
  deadBody: t("setup.deadBody"),
  unreachable: t("auth.unreachable"),
};
